import { render, staticRenderFns } from "./modalSua.vue?vue&type=template&id=71afcf2c&"
import script from "./modalSua.vue?vue&type=script&lang=js&"
export * from "./modalSua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports